// import { fetchLectures, fetchNotification } from '@fe-news/components/Aside/AnueLecture/useFetchLecture';
import { fetchNews24h } from '@fe-news/components/Aside/News24h/hooks/use-fetch-news24h';
// import { fetchFeatureReport } from '@fe-news/components/Aside/NewsFeatureReport/useFetchFeatureReport';
import { fetchNewsIssue } from '@fe-news/components/Aside/NewsIssue/hook/use-fetch-news-issue';
// import { fetchTwStockExpert } from '@fe-news/components/Aside/NewsTwStockExpert/hooks/useFetchTwStockExpert';
// import { fetchRecentTopic } from '@fe-news/components/Aside/RecentTopic/hooks/useFetchRecentTopic';
// import { fetchAsideCnyesAd } from '@fe-news/components/AsideCnyesAd/hooks/useFetchAsideCnyesAd';
// import { fetchNewsPopular } from '@fe-news/components/molecules/AsideNewsPopular/hooks/useFetchNewsPopular';
import { createQueryKeys } from '@lukemorales/query-key-factory';
import { fetchRelatedNewsById } from '@fe-news/components/NewsDetail/hooks/use-fetch-related-news';

const newsCategory = ({ category = '', limit }: { category: string; limit: number }) => ({
  queryKey: [category, limit] as [string, number],
  queryFn: () => fetchNewsIssue(category, limit)
});

const newsRelated = ({ id, limit }: { id: number; limit: number }) => ({
  queryKey: [id, limit] as [number, number],
  queryFn: () => fetchRelatedNewsById(id, limit)
});

// const newsCategories = ({ key }: { key: string }) => ({
//   queryKey: [key] as [string],
//   queryFn: () => fetchFeatureReport({ key })
// });

// const newsListCategory = ({
//   limit = 0,
//   category = 'all',
// }: {
//   limit?: number;
//   category: string;
// }) => ({
//   queryKey: [category, limit] as [string, number],
//   queryFn: () => fetchNewsPopular(category),
// });

// const adContents = ({ adId }: AsideCnyesAd.Parameters) => ({
//   queryKey: [`cnyesAd-${adId}`] as [string],
//   queryFn: () => fetchAsideCnyesAd(adId),
// });

// const newsListByTags = () => ({
//   queryKey: [''] as [string],
//   queryFn: () => fetchTwStockExpert()
// });

// const tagCloud = ({ kind, limit }: { kind: number; limit: number }) => ({
//   queryKey: [kind, limit] as [number, number],
//   queryFn: () => fetchRecentTopic({ kind, limit })
// });

const news24hList = (limit: number) => ({
  queryKey: [limit] as [number],
  queryFn: () => fetchNews24h(limit)
});

// const notificationLectures = () => ({
//   queryKey: [''] as [string],
//   queryFn: () => fetchLectures()
// });

// const notifications = () => ({
//   queryKey: [''] as [string],
//   queryFn: () => fetchNotification()
// });

const news = createQueryKeys('news', {
  newsCategory,
  newsRelated,
  // newsListCategory,
  // adContents,
  // newsListByTags,
  // tagCloud,
  news24hList
  // notificationLectures,
  // notifications
  // newsCategories
});

export default news;
